

const Heading = ({children}) => {
  return (
    <p className="text-2xl font-bold italic">{children}</p>
   );
};

export default Heading;
